import axios from "../libs/axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_ENDPOINT}/v1`;

class AllocationLotteryService {
  find(params) {
    return axios.get(`${API_URL}/allocation-lotteries`, {
      headers: authHeader(),
      params,
    });
  }

  create(data) {
    return axios.post(`${API_URL}/allocation-lottery`, data, {
      headers: authHeader(),
    });
  }
  findByID(id) {
    return axios.get(`${API_URL}/allocation-lottery/${id}`, {
      headers: authHeader(),
    });
  }

  update(data) {
    const _id = data._id;
    return axios.put(`${API_URL}/allocation-lottery/${_id}`, data, {
      headers: authHeader(),
    });
  }

  delete(id) {
    console.log("delete", id);
    return axios.delete(`${API_URL}/allocation-lottery/${id}`, {
      headers: authHeader(),
    });
  }

  async getStatuses() {
    const response = await axios.get(`${API_URL}/allocation-lottery-statuses`, {
      headers: authHeader(),
    });
    return response.data;
  }
}

export default new AllocationLotteryService();
